<form [formGroup]="primaryForm" (ngSubmit)="create()" *ngIf="level==99 || sendProgram==1 || sendInmediate==1 else notSend">
    <div class="card">
        <div class="card-header text-center" style="text-transform: uppercase;">AGREGAR RONDA</div>
        <div class="card-body">
            <div class="row gx-3 mb-3">
                <div class="col-md-5">
                    <div class="row">
                        <div class="col-md-12">
                            <label class="small mb-1" for="facility_id">Instalación</label>
                            <select class="form-control" formControlName="facility_id" (change)="updateTags()">
                                <option value="0">SELECCIONAR</option>
                                <!-- Aquí puedes iterar sobre las especialidades disponibles -->
                                <option *ngFor="let item of facilities" [value]="item.id">{{ item.name |
                                    uppercase }}
                                </option>
                            </select>
                        </div>
                        <div class="col-md-12">
                            <label class="small mb-1" for="rounds_type_id">Tipo de ronda</label>
                            <div class="input-group">
                                <select class="form-control" formControlName="rounds_type_id">
                                    <option value="0">SELECCIONAR</option>
                                    <!-- Aquí puedes iterar sobre las especialidades disponibles -->
                                    <option *ngFor="let type of types" [value]="type.id">{{ type?.tag |
                                        uppercase }}
                                    </option>
                                </select>
                                <span class="input-group-text"
                                    *ngIf="primaryForm.get('rounds_type_id').value==2">Secuencia</span>
                                <div class="input-group-text" *ngIf="primaryForm.get('rounds_type_id').value==2">
                                    <input class="form-check-input mt-0" type="checkbox" value="1"
                                        aria-label="Checkbox for following text input" formControlName="repeats">
                                </div>

                            </div>

                        </div>
                        <div class="col-md-12 mt-1"
                            *ngIf="primaryForm.get('rounds_type_id').value==2 && primaryForm.get('repeats').value==1 ">
                            <label class="small mb-1" for="start_date">Hasta</label>
                            <div class="input-group mb-3">
                                <div class="input-group-text">
                                    <i class="fa-solid fa-calendar-check"></i>
                                </div>
                                <input type="date" class="form-control" formControlName="repeat_date">
                            </div>
                        </div>
                        <div class="col-md-12 mt-1"   *ngIf="primaryForm.get('rounds_type_id').value==2 && primaryForm.get('repeats').value==1 ">
                            <label class="small mb-1" for="rut">Selector de Días</label>
                            <div class="input-group">
                                <div *ngFor="let dia of allDays" class="form-check form-check-inline">
                                    <input type="checkbox" class="form-check-input" [id]="dia" [value]="dia"
                                        [checked]="primaryForm.get('xdays').value.includes(dia)"
                                        (change)="toggleDaySelection(dia)" />
                                    <label class="form-check-label" [for]="dia">{{ dia }}</label>
                                </div>
                            </div>
                            <div *ngIf="primaryForm.hasError('atLeastOneDaySelected') && primaryForm.get('xdays').touched"
                                class="text-danger">
                                Al menos un día debe ser seleccionado.
                            </div>
                        </div>
                        <div class="col-md-12">
                            <label class="form-label" for="rounds_type_id">Correo de notificación</label>
                            <div class="input-group">
                                <span class="input-group-text" id="basic-addon1">
                                    <i class="fa-regular fa-envelope"></i>
                                </span>
                                <input class="form-control" type="email" formControlName="email_notification">
                                <span class="input-group-text" id="basic-addon1">
                                    <small>En caso de atraso.</small>
                                </span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="small mb-1" for="start_date">Fecha y Hora de inicio</label>
                            <input type="datetime-local" class="form-control" formControlName="start_date">
                        </div>
                        <div class="col-md-6">
                            <label class="small mb-1" for="end_date">Fecha y Hora de fin</label>
                            <input type="datetime-local" class="form-control" formControlName="end_date">
                        </div>
                        <div class="col-md-12 mt-1" *ngIf="facility?.image_path">
                            <label class="form-label" for="end_date">Mapa instalación</label>
                            <br>
                            <button type="button" (click)="showMaps=!showMaps" class="btn btn-sm btn-secondary"><i
                                    class="fa-solid fa-map-location-dot"></i></button><br>
                            <div class="image-container" *ngIf="showMaps">
                                <img class="mb-2 zoomable-image" style="cursor: pointer; width:100%"
                                    [src]="facility?.image_path" (error)="handleImageError()" />
                            </div>
                        </div>
                        <div class="col-md-12 mt-1">
                            <button [disabled]="tagsAvailable?.length<=0" class="btn btn-primary w-100"
                                [ngClass]="{'btn-success':primaryForm.get('rounds_type_id')?.value == 3,'btn-primary':primaryForm.get('rounds_type_id')?.value != 3}"
                                type="submit"
                                *ngIf="primaryForm.get('rounds_type_id')?.value>0&&primaryForm.get('facility_id')?.value>0">{{"ENVIAR"}}</button>
                        </div>
                    </div>


                </div>
                <div class="col-md-7">
                    <app-drop-tags [maxHeight]="500" [tagsAvailable]="tagsAvailable" [tagsSelected]="tagsSelected"
                        (onTagSelected)="tagsSelected=$event" />
                </div>
            </div>
            <div *ngIf=" primaryForm.get('rounds_type_id')?.value==3" class="alert alert-warning">
                <strong>Importante</strong>, al enviar sera dirigida a todos los dispositivos asociadas a esa
                instalación de forma inmediata.
            </div>
        </div>
    </div>
</form>

<ng-template #notSend>
    <div class="alert alert-danger">No esta autorizado para enviar rondas</div>
</ng-template>